import React from 'react';
import { connect } from 'react-redux';

const EpixBoxesTableRow = ({ box, companies, selectedCompany, deleteMode }) => {
  const onClick = async e => {
    try {
      if (deleteMode) {
        const filter = {
          name: 'company',
          value: box?.Company[0]?.name,
          suggestion: { ...box?.Company[0] },
        };
        selectedCompany(filter);
      } else {
        const companyID = e.currentTarget.id;
        const suggestion = companies.docs.find(item => {
          return item._id === companyID;
        });
        const filter = {
          name: 'company',
          value: suggestion.name,
          suggestion: { ...suggestion },
        };
        selectedCompany(filter);
      }
    } catch (error) {}
  };
  return (
    <tr id={box?.Company?.[0]?._id} onClick={onClick} className="row-hover">
      <td>{box?.Company?.[0]?.name}</td>
      <td>{box?.total}</td>
      <td>{box?.online}</td>
      <td>{box?.offline}</td>
      <td>{box?.unmonitored}</td>
      {/*<td>{box?.alarmed}</td>*/}
    </tr>
  );
};

const mapStateToProps = state => ({
  companies: state.AppState.companies,
});

export default connect(
  mapStateToProps,
  null,
)(EpixBoxesTableRow);
